import { render } from "./BrandsIndex.vue?vue&type=template&id=33164348"
import script from "./BrandsIndex.vue?vue&type=script&lang=js"
export * from "./BrandsIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__